import React, { useEffect, useContext, useState } from "react";
import { Link } from "react-router-dom";
import "../../assets/scss/account/register.scss";
import { handleLogin } from "../../redux/authentication";
import { handlePlanState } from "../../redux/layout";
import { useLocation, useHistory } from "react-router-dom";
import { AbilityContext } from "@src/utility/context/Can";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { useDispatch } from "react-redux";
import HeaderLogo from "../../components/header/headerLogo";
import Repository from "../../configs/axios/repository";
import marketingJpg from "../../assets/images/account/login.svg";
import view from "../../assets/images/account/veiw.png";
import hidenIcon from "../../assets/images/account/hideIcon.png";
import clear from "../../assets/images/account/clear.png";
import { Row, Col } from "reactstrap";
import Spinner from "../../@core/components/spinner/Fallback-spinner";

const LoginCover = () => {
    const history = useHistory();
    const locationState = useLocation();
    const dispatch = useDispatch();
    const ability = useContext(AbilityContext);
    const [isNone, setIsNone] = useState(false);
    const [loadingData, setLoadingData] = useState(true);
    const [isNoneVerify, setIsNoneVerify] = useState(false);
    const [isNoneLogin, setIsNoneLogin] = useState(false);
    const [showPasword, setShowPasword] = useState(false);
    const [password, setPassword] = useState("");
    const [showEmailClear, setShowEmailClear] = useState(false);
    const [loginData, setLoginData] = useState({});
    const [dispechData, setDispechData] = useState({});
    const [isRightCode, setIsRightCode] = useState(false);
    const [isRightLogin, setIsRightLogin] = useState(false);
    const [isCode, setIsCode] = useState(false);
    const firstLogin = localStorage.getItem("firstLogin");
    const [showInstructorVerify, setShowInstructorVerify] = useState(false);
    const queryParameters = new URLSearchParams(window.location.search);
    const course_id = queryParameters?.get("course_id");
    const courseName = queryParameters?.get("course_name");
    const emailNotDecoding = queryParameters.get("email");
    const email = decodeURIComponent(queryParameters?.get("email"))?.replace(
        / /g,
        "+"
    );

    const sendVerifyCode = async (values) => {
        let data = {
            email: values.email,
            user_name: values.user_name,
            verification_code: values.verification_code,
        };
        const result = await Repository.postRequest(
            `api/users/sendVerificationEmailCode`,
            data
        );

        setLoadingData(true);
    };
    const checkVerifedCode = async (values) => {
        if (values.code == loginData.verification_code) {
            dispatch(handleLogin(dispechData));
            dispatch(handlePlanState(loginData.subscriptionType));
            ability.update([
                {
                    action: "manage",
                    subject: "all",
                },
            ]);
            localStorage.setItem("firstLogin", true);
            setIsCode(false);
            history.push("/");
        } else {
            setIsRightCode(true);
        }
    };

    const loginColl = async (values, loginWithoutCode) => {
        if (loginWithoutCode) {
            setLoadingData(false);
            const result = await Repository.postRequest(`api/users/login`, {
                email: values.email,
                password: values.password,
            });

            if (result.data.data == "Verify Error") {
                setIsNoneVerify(true);
            } else if (
                result.data?.success === true &&
                result.data.data.userToken.access_token != undefined
            ) {
                if (result.data.data.status == "deleted") {
                    setIsNoneLogin(true);
                } else {
                }
            } else {
                setIsNone(true);
            }
            setLoadingData(true);
        } else {
            setIsRightCode(false);
            setShowInstructorVerify(false);
            setIsNone(false);
            setIsNoneVerify(false);

            const result = await Repository.postRequest(
                `api/users/login`,
                values
            );
            if (result.data.data == "Verify Error") {
                setIsNoneVerify(true);
            } else if (
                result.data?.success === true &&
                result.data.data.userToken.access_token != undefined
            ) {
                if (result.data.data.status == "deleted") {
                    setIsNoneLogin(true);
                } else if (result.data.data.role == "instructor") {
                    if (result.data.data.is_verified_instructor == true) {
                        setLoginData(result.data.data);
                        setDispechData({
                            ...result.data.data.userToken,
                            userId: result.data.data.userId,
                            role: result.data.data.role,
                        });
                        if (firstLogin == "true") {
                            dispatch(
                                handleLogin({
                                    ...result.data.data.userToken,
                                    userId: result.data.data.userId,
                                    role: result.data.data.role,
                                })
                            );
                            dispatch(
                                handlePlanState(
                                    result.data.data.subscriptionType
                                )
                            );
                            ability.update([
                                {
                                    action: "manage",
                                    subject: "all",
                                },
                            ]);
                            setIsCode(false);
                            setLoadingData(true);
                            history.push("/");
                        } else {
                            setIsCode(true);
                            sendVerifyCode(result.data.data);
                        }
                    } else {
                        setShowInstructorVerify(true);
                    }
                } else if (result.data.data.role == "student") {
                    setLoginData(result.data.data);
                    setIsCode(true);

                    setDispechData({
                        ...result.data.data.userToken,
                        userId: result.data.data.userId,
                        role: result.data.data.role,
                    });

                    if (firstLogin == "true") {
                        dispatch(
                            handleLogin({
                                ...result.data.data.userToken,
                                userId: result.data.data.userId,
                                role: result.data.data.role,
                            })
                        );
                        dispatch(
                            handlePlanState(result.data.data.subscriptionType)
                        );
                        ability.update([
                            {
                                action: "manage",
                                subject: "all",
                            },
                        ]);
                        setIsCode(false);
                        setLoadingData(true);
                        if (course_id != undefined) {
                            history.push({
                                pathname: "/invateUser",
                                search: emailNotDecoding
                                    ? `course_id=${course_id}&email=${email}&course_name=${courseName}`
                                    : `course_id=${course_id}&course_name=${courseName}`,
                            });
                        } else {
                            history.push("/");
                        }
                    } else {
                        setIsCode(true);
                        sendVerifyCode(result.data.data);
                    }
                }
            } else {
                setIsNone(true);
            }
        }
    };
    const handleClear = (formik, nameFild) => {
        if (nameFild == "user_name") {
            formik.setFieldValue("user_name", "");
        } else if (nameFild == "email") {
            formik.setFieldValue("email", "");
        }
    };

   
    return loadingData ? (
        isCode ? (
            <div>
                <HeaderLogo />
                <div className="sectionParentDiv">
                    <div className="registerContent ">
                        <div>
                            <div className="rounded mx-auto d-block registrField">
                                <h1>Log In</h1>

                                <p>
                                    Verification code has been sent to the email
                                    address you entered, please confirm it.
                                </p>
                                <div>
                                    <Formik
                                        initialValues={{
                                            code: "",
                                        }}
                                        validate={(values) => {
                                            const errors = {};

                                            if (values.code.length > 5) {
                                                errors.code =
                                                    "Number must be exactly 5 digits";
                                            }

                                            return errors;
                                        }}
                                        onSubmit={(values) => {
                                            checkVerifedCode(values);
                                        }}
                                    >
                                        {({ isSubmitting }) => (
                                            <Form className="formikEvents">
                                                <Row>
                                                    <Col
                                                        xl="12"
                                                        md="12"
                                                        sm="12"
                                                    >
                                                        <Field
                                                            className="formikInput"
                                                            type="text"
                                                            name="code"
                                                            placeholder="Verify code*"
                                                            maxLength={5}
                                                        />
                                                        <ErrorMessage
                                                            className="errorMessage"
                                                            name="code"
                                                            component="div"
                                                        />
                                                        <div>
                                                            <span
                                                                className={
                                                                    isRightCode
                                                                        ? "errorMessage"
                                                                        : "errorMessageNone"
                                                                }
                                                            >
                                                                The verification
                                                                code is
                                                                incorrect.
                                                            </span>
                                                        </div>
                                                    </Col>
                                                    <Col
                                                        xl="12"
                                                        md="12"
                                                        sm="12"
                                                    >
                                                        <div className="modalBtn">
                                                            <button
                                                                type="submit"
                                                                className="btnOk"
                                                            >
                                                                Send
                                                            </button>
                                                            <button
                                                                onClick={() => {
                                                                    setIsCode(
                                                                        false
                                                                    );
                                                                }}
                                                                className="btnCancel"
                                                            >
                                                                Cancel
                                                            </button>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </Form>
                                        )}
                                    </Formik>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="marketingDivJpg ">
                        <img src={marketingJpg} alt="marketingJpg" />
                    </div>
                </div>
            </div>
        ) : (
            <div>
                <HeaderLogo />
                <div className="sectionParentDiv">
                    <div className="registerContent ">
                        <div>
                            <div className="rounded mx-auto d-block registrField">
                                <h1>Log In</h1>
                                <p>
                                    Please fill your detail to access your
                                    account.
                                </p>
                                <div
                                    className={
                                        isNone
                                            ? " errorMessageLogin "
                                            : "errorMessageLoginNone"
                                    }
                                >
                                    <h3>
                                        The email or password you entered isn’t
                                        connected to an account. Find your
                                        account and log in.
                                    </h3>
                                </div>
                                <div
                                    className={
                                        isNoneVerify
                                            ? " errorMessageLogin "
                                            : "errorMessageLoginNone"
                                    }
                                >
                                    <h3>
                                        Please check your email and confirm
                                        verification․
                                    </h3>
                                </div>
                                <div
                                    className={
                                        isNoneLogin
                                            ? " errorMessageLogin "
                                            : "errorMessageLoginNone"
                                    }
                                >
                                    <h3>
                                        You do not have permission to access the
                                        page.
                                    </h3>
                                </div>
                                <Formik
                                    initialValues={{
                                        email: "",
                                        password: "",
                                    }}
                                    validate={(values) => {
                                        const errors = {};
                                        const specialSymbols =
                                            /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/;
                                        const letters = /[a-zA-Z]/;

                                        if (values.password) {
                                            setPassword(values.password);
                                        }

                                        if (values.email) {
                                            setShowEmailClear(true);
                                        }

                                        if (!values.email) {
                                            errors.email = "Email is required.";
                                        } else if (
                                            !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(
                                                values.email
                                            )
                                        ) {
                                            errors.email =
                                                "Invalid email address";
                                        }

                                        if (!values.email) {
                                            setShowEmailClear(false);
                                            errors.email =
                                                "Email Address is required.";
                                        }

                                        if (!values.password) {
                                            setPassword(values.password);
                                            errors.password =
                                                "Password is required.";
                                        } else if (values.password.length < 6) {
                                            errors.password =
                                                "Password must consist of 6 members";
                                        } else if (
                                            !specialSymbols.test(
                                                values.password
                                            ) ||
                                            !letters.test(values.password)
                                        ) {
                                            errors.password =
                                                "Password doesn’t meet the require, password should be minimum 6 characters, 1 special symbol, 1 letter.";
                                        }

                                        return errors;
                                    }}
                                    onSubmit={(values, { setSubmitting }) => {
                                        // sendVerifyCode(values);
                                        loginColl(values);
                                    }}
                                >
                                    {(formik) => (
                                        <Form className="formikRegister">
                                            <div className="labelInputs">
                                                Email
                                            </div>

                                            <Field
                                                className="formikInput"
                                                type="email"
                                                name="email"
                                                placeholder="Email Address"
                                            />
                                            <div className="viewIcon">
                                                {showEmailClear ? (
                                                    <img
                                                        onClick={() => {
                                                            handleClear(
                                                                formik,
                                                                "email"
                                                            );
                                                        }}
                                                        src={clear}
                                                        alt="clear"
                                                    />
                                                ) : (
                                                    ""
                                                )}
                                            </div>
                                            <ErrorMessage
                                                className="errorMessage"
                                                name="email"
                                                component="div"
                                            />
                                            <div>
                                                <span
                                                    className={
                                                        isRightLogin
                                                            ? "errorMessage"
                                                            : "errorMessageNone"
                                                    }
                                                >
                                                    Login is not correct.
                                                </span>
                                            </div>
                                            <div className="labelInputs">
                                                Password
                                            </div>
                                            <Field
                                                className="formikInput"
                                                type={
                                                    showPasword
                                                        ? "text"
                                                        : "password"
                                                }
                                                name="password"
                                                placeholder="Password"
                                            />
                                            <div
                                                className={
                                                    password
                                                        ? "viewIcon"
                                                        : "viewIconNone"
                                                }
                                            >
                                                <img
                                                    onClick={() => {
                                                        if (showPasword) {
                                                            setShowPasword(
                                                                false
                                                            );
                                                        } else {
                                                            setShowPasword(
                                                                true
                                                            );
                                                        }
                                                    }}
                                                    src={
                                                        showPasword
                                                            ? view
                                                            : hidenIcon
                                                    }
                                                    alt="view"
                                                />
                                            </div>
                                            <ErrorMessage
                                                className="errorMessage"
                                                name="password"
                                                component="div"
                                            />
                                            <div className="checkboxDiv d-flex justify-content-between align-items-center">
                                                <div className=" d-flex ">
                                                    <Field
                                                        className="formikChackbox"
                                                        type="checkbox"
                                                        name="emailupdatesCheckbox"
                                                    />
                                                    <span>Remember me</span>
                                                </div>
                                                <span className="forgotSpan">
                                                    <Link to="/forgotPassword">
                                                        Forgot Password?
                                                    </Link>
                                                </span>
                                            </div>
                                            {showInstructorVerify ? (
                                                <div className="mt-3 errorMessage">
                                                    You have not yet been
                                                    granted instructor
                                                    permission by an
                                                    administrator.
                                                </div>
                                            ) : (
                                                ""
                                            )}
                                            <div className="regSubmit mt-2">
                                                <button type="submit">
                                                    Sign in
                                                </button>
                                            </div>
                                        </Form>
                                    )}
                                </Formik>

                                {/* <div className="d-flex justify-content-center mt-3">
                                    <div id="signInDiv"></div>
                                </div> */}

                                <div className="text-center mt-3">
                                    <span className="forgotSpan text-center">
                                        Don’t have an account?&nbsp;&nbsp;
                                        {course_id != undefined ? (
                                            <Link
                                                to={{
                                                    pathname: "/register",
                                                    search: emailNotDecoding
                                                        ? `course_id=${course_id}&email=${email}&course_name=${courseName}`
                                                        : `course_id=${course_id}&course_name=${courseName}`,
                                                }}
                                            >
                                                Sign up
                                            </Link>
                                        ) : (
                                            <Link to="/register">Sign up</Link>
                                        )}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="marketingDivJpg ">
                        <img src={marketingJpg} alt="marketingJpg" />
                    </div>
                </div>
            </div>
        )
    ) : (
        <Spinner spiner={true} />
    );
};

export default LoginCover;
